import * as XLSX from "xlsx";

const SHEET_NAME = "Products";
const FILENAME = "outward_products_template.xlsx";

const FEFO_HEADERS = [
  "productSKU",
  "productName",
  "dispatchQuantity",
];

const MANUAL_HEADERS = [
  "productSKU",
  "productName",
  "dispatchQuantity",
  "batchNumber",
  "available",
  "allocQty",
];

function getBatchAvailableForExport(batch) {
  const value =
    batch?.availableQty ??
    batch?.availableQuantity ??
    batch?.available ??
    batch?.remainingQty ??
    batch?.qtyAvailable ??
    batch?.quantity;
  const num = Number(value);
  return Number.isFinite(num) ? num : "";
}

function buildFefoExportRows(products = []) {
  return products.map((p) => [
    p.sku || "",
    p.productName || p.skuName || p.description || "",
    "",
  ]);
}

function buildManualExportRows(products = []) {
  const rows = [];
  products.forEach((p) => {
    const sku = p.sku || "";
    const name = p.productName || p.skuName || p.description || "";
    const dispatchQty = p.dispatchQuantity ?? "";
    const batches = Array.isArray(p.batches) ? p.batches : [];
    if (!batches.length) {
      rows.push([sku, name, dispatchQty, "", "", ""]);
      return;
    }
    batches.forEach((batch, index) => {
      rows.push([
        index === 0 ? sku : "",
        index === 0 ? name : "",
        index === 0 ? dispatchQty : "",
        batch.batchNumber || "",
        getBatchAvailableForExport(batch),
        "",
      ]);
    });
  });
  return rows;
}

/**
 * Download Excel template for outward create product table.
 * @param {Array<{ _id?: string, sku?: string, skuName?: string, productName?: string, description?: string, dispatchQuantity?: string|number, batches?: Array }>} products
 * @param {{ allocationMethod?: string }} [options]
 */
export function downloadOutwardProductsTemplate(products = [], options = {}) {
  const method = String(options.allocationMethod || "FEFO").toUpperCase();
  const isManual = method === "MANUAL";
  const headers = isManual ? MANUAL_HEADERS : FEFO_HEADERS;
  const sampleRows = products.length === 0
    ? (isManual
        ? [
            ["SKU-101", "Belgian Dark Chocolate 100ml", 1, "BATCH-INV001-01", 1933, ""],
            ["", "", "", "B001", 1, ""],
          ]
        : [["SKU-002", "Sample Product", 40]])
    : [];
  const dataRows = isManual ? buildManualExportRows(products) : buildFefoExportRows(products);
  const rows = [headers, ...sampleRows, ...dataRows];
  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws["!cols"] = isManual
    ? [{ wch: 18 }, { wch: 28 }, { wch: 16 }, { wch: 22 }, { wch: 12 }, { wch: 12 }]
    : [{ wch: 18 }, { wch: 28 }, { wch: 16 }];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
